// 扩展API加载完毕，现在可以正常调用扩展API
var isPlus = false
function onPlusReady() {
    isPlus = true
}
document.addEventListener('plusready', onPlusReady, false)

module.exports = {
    isPlus
}



// WEBPACK FOOTER //
// ./src/js/isPlus.js